"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AnalyticsProvider_1 = require("../AnalyticsProvider");
/**
 * This provider uses Adobe Analytics
 */
var FCAProvider = /** @class */ (function (_super) {
    __extends(FCAProvider, _super);
    function FCAProvider(name, config) {
        var _this = _super.call(this, name) || this;
        _this.config = config;
        return _this;
    }
    FCAProvider.prototype.getFormStartEventObject = function (formType, vehicle) {
        return {
            type: "CustomTagEvent",
            eventName: "start",
            eventAction: "form",
            attributes: {
                isDigitalRetailing: true,
                formDescription: "lead",
                formType: formType,
                displayType: "modal",
                displayFormat: "modal",
                vehicleMake: vehicle === null || vehicle === void 0 ? void 0 : vehicle.make,
                vehicleModel: vehicle === null || vehicle === void 0 ? void 0 : vehicle.model,
                vehicleStatus: vehicle === null || vehicle === void 0 ? void 0 : vehicle.type,
                vehicleTrim: vehicle === null || vehicle === void 0 ? void 0 : vehicle.trim,
                vehicleVin: vehicle === null || vehicle === void 0 ? void 0 : vehicle.vin,
                vehicleYear: vehicle === null || vehicle === void 0 ? void 0 : vehicle.year,
            },
        };
    };
    FCAProvider.prototype.getFormFinishEventObject = function (formType, dealId, vehicle) {
        return {
            type: "CustomTagEvent",
            eventName: "submit",
            eventAction: "form",
            attributes: {
                isDigitalRetailing: true,
                formDescription: "lead",
                formType: formType,
                leadId: dealId,
                displayType: "modal",
                displayFormat: "modal",
                vehicleMake: vehicle === null || vehicle === void 0 ? void 0 : vehicle.make,
                vehicleModel: vehicle === null || vehicle === void 0 ? void 0 : vehicle.model,
                vehicleStatus: vehicle === null || vehicle === void 0 ? void 0 : vehicle.type,
                vehicleTrim: vehicle === null || vehicle === void 0 ? void 0 : vehicle.trim,
                vehicleVin: vehicle === null || vehicle === void 0 ? void 0 : vehicle.vin,
                vehicleYear: vehicle === null || vehicle === void 0 ? void 0 : vehicle.year,
            },
        };
    };
    FCAProvider.prototype.getCTAEventObject = function (toolName) {
        return {
            type: "CustomTagEvent",
            eventName: "CTA",
            eventAction: "buttonClick",
            attributes: {
                linkText: "digital-retailing:".concat(toolName),
                isDigitalRetailing: true,
            },
        };
    };
    FCAProvider.prototype.sendEvent = function (event) {
        if (!this.eventHandler) {
            return;
        }
        this.eventHandler(event);
    };
    FCAProvider.prototype.opened = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerSession("opened", function () {
            _this.sendEvent(_this.getFormStartEventObject("build my deal", vehicle));
        });
    };
    // This function means, roughly, "the customer has selected a vehicle and a payment offer" to FCA
    // This happens in two different scenarios between redline and electric.
    // In order to avoid "finishing" a lead for other providers while also sending a 'build my deal' submit for FCA.
    // TODO: Revisit when this should fire for Redline for shift v2. Remove comments if Redline Shift v2 doesn't happen.
    // Notes from engine before paymentOfferSelected was removed:
    // Should be called when the customer has moved to a place they can no longer alter their offer.
    // This is fired at the same time as leadFormFinish in Electric
    // This is fired at the same time as calculationFinish in Redline
    FCAProvider.prototype.leadFormFinished = function (dealId, vehicle) {
        this.sendEvent(this.getFormFinishEventObject("build my deal", dealId, vehicle));
    };
    FCAProvider.prototype.tradeInFormStarted = function (dealId, vehicle) {
        this.sendEvent(this.getFormStartEventObject("add a trade in", vehicle));
    };
    FCAProvider.prototype.tradeInFormFinished = function (dealId, vehicle) {
        this.sendEvent(this.getFormFinishEventObject("add a trade in", dealId, vehicle));
    };
    FCAProvider.prototype.softCreditFormStarted = function (dealId, vehicle) {
        var _this = this;
        this.handleOnlyOncePerSession("softCreditFormStarted", function () {
            _this.creditAppStart(vehicle);
        });
    };
    FCAProvider.prototype.softCreditFormFinished = function (dealId, vehicle, applicationId) {
        var _this = this;
        this.handleOnlyOncePerSession("softCreditFormFinished", function () {
            _this.creditAppComplete(dealId, vehicle, applicationId);
        });
    };
    FCAProvider.prototype.hardCreditFormStarted = function (dealId, vehicle) {
        this.creditAppStart(vehicle);
    };
    FCAProvider.prototype.hardCreditFormFinished = function (dealId, vehicle, applicationId) {
        this.creditAppComplete(dealId, vehicle, applicationId);
    };
    FCAProvider.prototype.creditAppComplete = function (dealId, vehicle, applicationId) {
        // FCA doesn't distinguish between hard-pull and soft-pull for credit app
        var eventObj;
        if (!applicationId) {
            // if applicationId is undefined, do not set leadId in the event object
            eventObj = this.getFormFinishEventObject("apply for credit", dealId, vehicle);
            delete eventObj.attributes.leadId;
        }
        else {
            dealId = String(applicationId);
            eventObj = this.getFormFinishEventObject("apply for credit", dealId, vehicle);
        }
        this.sendEvent(eventObj);
    };
    FCAProvider.prototype.testDriveFormStarted = function (dealId, vehicle) {
        this.sendEvent(this.getFormStartEventObject("test drive", vehicle));
    };
    FCAProvider.prototype.testDriveFormFinished = function (dealId, vehicle) {
        this.sendEvent(this.getFormFinishEventObject("test drive", dealId, vehicle));
        this.sendEvent(this.getCTAEventObject("test drive"));
    };
    /**
     * If we were passed an eventCallback, send the payload there.
     *     This is typical in Electric, where we want to use the parent window (dealer website) digitalData.
     * If we were *not* passed an eventCallback, look for window.digitalData.newEvent in our context
     *     This is typical in Redline
     * Google Tag Manager uses a similar object-on-window, and we observed a race condition when we tried to hold a reference directly to a deep method on that object.
     * It should be safer to always use window.digitalData.newEvent and not hold a direct reference to the `newEvent` method.
     * @param payload
     * @protected
     */
    FCAProvider.prototype.eventHandler = function (payload) {
        var eventHandler = this.config.eventCallback || window.digitalData.newEvent;
        eventHandler(payload);
    };
    FCAProvider.prototype.creditAppStart = function (vehicle) {
        this.sendEvent(this.getFormStartEventObject("apply for credit", vehicle));
        this.sendEvent(this.getCTAEventObject("apply for credit"));
    };
    return FCAProvider;
}(AnalyticsProvider_1.AnalyticsProvider));
exports.default = FCAProvider;
